package app.nestbridge.feature.profile.presentation

import app.nestbridge.feature.profile.screen.CreateProfessionalProfileScreen
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.Navigator
import com.slack.circuit.runtime.presenter.Presenter
import com.slack.circuit.runtime.screen.Screen
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
@Origin(CreateProfessionalProfilePresenter::class)
public class CreateProfessionalProfilePresenterFactory(
  private val factory:
      (screen: CreateProfessionalProfileScreen, navigator: Navigator) -> CreateProfessionalProfilePresenter,
) : Presenter.Factory {
  override fun create(
    screen: Screen,
    navigator: Navigator,
    context: CircuitContext,
  ): Presenter<*>? = when (screen) {
    is CreateProfessionalProfileScreen -> factory(screen, navigator)
    else -> null
  }
}
